import React from 'react';
import styled from 'styled-components';

type Props = {
  count: number;
  activeIdx: number;
  onSelect: (idx: number) => void;
};

const CarouselPips = ({ count, activeIdx, onSelect }: Props) => (
  <Container>
    {Array.from({ length: count }, (_, idx) => (
      <Pip
        key={idx}
        type="button"
        aria-label={`Go to slide ${idx + 1}`}
        aria-current={idx === activeIdx}
        $isActive={idx === activeIdx}
        onClick={() => onSelect(idx)}
      />
    ))}
  </Container>
);

const Container = styled.div`
  display: none;

  ${({ theme }) => theme.breakpoints.down('md')} {
    display: flex;
    justify-content: center;
    margin-top: 13px;
  }
`;

// Tap target fills the 8px gaps between 10px dots (18px pitch), 24px tall.
const Pip = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 24px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;

  &::before {
    content: '';
    box-sizing: border-box;
    width: 10px;
    height: 10px;
    border: 2px solid ${({ theme }) => theme.colors.lightBlue};
    border-radius: 50%;
    background-color: ${({ theme, $isActive }) =>
      $isActive ? theme.colors.lightBlue : 'transparent'};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.topicBlue};
    outline-offset: 2px;
  }
`;

export default CarouselPips;
